import Transform from "@ember-data/serializer/transform";

export default class ChemotherapiesTransform extends Transform {
  override deserialize(serialized) {
    serialized?.forEach(chemotherapy => {
      // Make sure date are of type Date and not string.
      // This is useful when passing the date in a DatePicker, which must have a Date and not a string.
      if (chemotherapy.therapyOne) {
        chemotherapy.therapyOne = new Date(chemotherapy.therapyOne);
      }
      if (chemotherapy.therapyTwo) {
        chemotherapy.therapyTwo = new Date(chemotherapy.therapyTwo);
      }
      if (chemotherapy.therapyThree) {
        chemotherapy.therapyThree = new Date(chemotherapy.therapyThree);
      }
      if (chemotherapy.therapyFour) {
        chemotherapy.therapyFour = new Date(chemotherapy.therapyFour);
      }
      if (chemotherapy.therapyFive) {
        chemotherapy.therapyFive = new Date(chemotherapy.therapyFive);
      }
      if (chemotherapy.lastTherapy) {
        chemotherapy.lastTherapy = new Date(chemotherapy.lastTherapy);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    chemotherapies: ChemotherapiesTransform;
  }
}
